<template>
  <footer class="footer has-background-black-bis has-text-grey">
    <div class="scroll-top">
      <button class="button is-primary is-rounded" @click="$scrollToTop">
        <icon name="fa-chevron-up" />
      </button>
    </div>
    <div class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-4">
            <div class="slot">
              <div class="logo">
                <logo color="white" />
              </div>
              <div class="about">
                <p>{{ templates[T.Footer.TITLE] }}</p>
                <p>{{ templates[T.Footer.ADDRESS] }}</p>
              </div>
              <div class="about">
                <p>{{ templates[T.Footer.DESC] }}</p>
              </div>
              <div class="buttons">
                <a
                  :href="phoneHref"
                  class="button is-light is-outlined is-rounded is-small"
                  v-if="templates[T.Footer.PHONE]"
                >
                  <icon name="fa-phone-alt" />
                  <span>{{ templates[T.Footer.PHONE] }}</span>
                </a>
                <a
                  :href="mailHref"
                  class="button is-light is-outlined is-rounded is-small"
                  v-if="templates[T.Footer.MAIL]"
                >
                  <icon name="fa-envelope" />
                  <span>{{ templates[T.Footer.MAIL] }}</span>
                </a>
              </div>
              <p class="app-info" v-if="meta.version">
                Wersja: {{ meta.version }}
              </p>
              <p class="app-info" v-if="build">Kompilacja: {{ build }}</p>
            </div>
          </div>
          <div class="column is-2">
            <div class="slot">
              <p class="slot__title font--condensed">Nawigacja</p>
              <ul>
                <li>
                  <a @click="goToHomeAndScrollTo('hero')">Strona główna</a>
                </li>
                <li>
                  <a @click="goToHomeAndScrollTo('tv')">Telewizja</a>
                </li>
                <li>
                  <a @click="goToHomeAndScrollTo('internet')">Internet</a>
                </li>
                <li>
                  <a @click="goToHomeAndScrollTo('contact')">Kontakt</a>
                </li>
                <li>
                  <a
                    class="has-text-link"
                    @click="goToAdminPanel"
                    v-if="isSignedIn"
                    >Panel administratora</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="column is-2">
            <div class="slot">
              <p class="slot__title font--condensed">Użytkownik</p>
              <ul>
                <li>
                  <router-link
                    to="/messages"
                    @click.native="$immediatelyScrollToTop"
                    >Ogłoszenia</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/program"
                    @click.native="$immediatelyScrollToTop"
                    >Program TV</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/videos"
                    @click.native="$immediatelyScrollToTop"
                    >Archiwum materiałów</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="column">
            <div class="slot">
              <p class="slot__title font--condensed">Ogłoszenia</p>
              <ul>
                <li v-for="message in favoredMessages" :key="message.id">
                  <router-link :to="`/messages/${message.id}`">{{
                    message.title
                  }}</router-link>
                </li>
                <li>
                  <router-link
                    to="/messages"
                    @click.native="$immediatelyScrollToTop"
                    class="see-more font--condensed"
                    >Zobacz więcej</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="bottom-footer">
        <div class="section">
          <div class="columns is-desktop">
            <div class="column is-narrow author is-unselectable">
              Made by Bartłomiej Pluta
            </div>
            <div class="column menu">
              <ul>
                <li>
                  <router-link
                    to="/privacy"
                    @click.native="$immediatelyScrollToTop"
                    >Polityka prywatności</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/gdpr"
                    @click.native="$immediatelyScrollToTop"
                    >Informacja RODO</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="column is-narrow copyright is-unselectable">
              &copy; {{ year }} OTvK
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

import M from "%const/messages";
import T from "%const/templates";

import { WithTemplates } from "%mixins";

import Logo from "./Logo";
import { Icon } from "%helpers";

export default {
  name: "app-footer",

  mixins: [
    WithTemplates({
      templates: [
        T.Footer.TITLE,
        T.Footer.ADDRESS,
        T.Footer.DESC,
        T.Footer.PHONE,
        T.Footer.MAIL
      ]
    })
  ],

  components: {
    Logo,
    Icon
  },

  props: {
    meta: Object,
    isSignedIn: Boolean
  },

  data() {
    return { T };
  },

  computed: {
    year() {
      return this.meta.year || new Date().getFullYear();
    },

    build() {
      return this.meta.build && this.meta.build.format("DD.MM.YYYY, HH:mm:ss");
    },

    phoneHref() {
      return (
        this.templates[T.Footer.PHONE] &&
        "tel:" + this.templates[T.Footer.PHONE].replace(/\D/g, "")
      );
    },

    mailHref() {
      return (
        this.templates[T.Footer.MAIL] &&
        "mailto:" + this.templates[T.Footer.MAIL]
      );
    },

    ...mapState({
      favoredMessages: state =>
        state.messages.favoredMessages.slice(0, M.Favored.LIMIT)
    })
  },

  methods: {
    async goToAdminPanel() {
      if (this.isSignedIn) {
        await this.$router.push("/admin");
        this.$immediatelyScrollToTop();
      }
    },

    async goToHomeAndScrollTo(step) {
      if (this.$route.name !== "home") {
        await this.$router.push("/home");
      }

      this.$scrollTo(`*[data-step="${step}"]`, 2000, {
        offset: -100
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  font-size: 0.8rem;
}

.scroll-top {
  width: 100%;
  text-align: center;
  transform: translateY(-50%);

  .button {
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
  }
}

a {
  color: $white;
  user-select: none;

  &:hover {
    color: $grey;
  }
}

.logo {
  width: 150px;
  padding-bottom: 1rem;
}

.about {
  padding: 0.5rem 0;
}

.buttons {
  padding-top: 1rem;
}

.slot {
  &__title {
    margin-bottom: 0.5rem;
    user-select: none;
  }
}

.app-info:first-child {
  margin-top: 1rem;
}

li:not(:last-child) {
  margin-bottom: 0.5rem;
}

.see-more {
  display: inline-block;
  margin-top: 1.5rem;

  &::after {
    content: "\f061";
    font-family: "Font Awesome 5 Pro";
    padding-left: 0.5rem;
    color: $grey-light;
  }
}

.bottom-footer {
  border-top: solid 1px $black-ter;

  li {
    font-size: 0.8rem;
  }

  @include from($tablet) {
    li {
      display: inline;

      &:not(:last-of-type) {
        &::after {
          content: "\00b7";
          padding: 0 1rem;
          font-weight: 900;
        }
      }
    }

    .menu {
      text-align: center;
    }
  }

  @include from($tablet) {
    .author {
      text-align: center;
    }

    .copyright {
      text-align: center;
    }
  }
}
</style>
